module.exports = __webpack_public_path__ + "static/media/item_5_34_comp.90185b55.png";